import React, { useEffect, useRef, useMemo } from 'react';

// 使用js计算文字省略号位置，替换原有文字为省略号，修复html2canvas导出图片不显示省略号问题
export function useTextOverflow(text: string | undefined, posterId: number) {
  const containerRef = useRef<HTMLDivElement>(null);
  const textsRef = useRef<HTMLElement>(null);
  const textDoms = useMemo(
    () =>
      text?.split('').map((i, index) => (
        <span key={`${posterId}-${index}`} className="text-unit">
          {i}
        </span>
      )),
    [text, posterId],
  );
  useEffect(() => {
    const titleDom = containerRef.current;
    const textsDom = textsRef.current;
    if (titleDom && textsDom) {
      const titleHeight = titleDom.clientHeight;
      const { height: textsHeight } = textsDom.getBoundingClientRect();
      if (textsHeight - titleHeight > 2) {
        const nodes = textsDom.children;
        const { bottom } = titleDom.getBoundingClientRect();
        let targetIndex: number | undefined;
        for (let i = 0; i < nodes.length; i++) {
          const spanNode = nodes[i];
          const { bottom: spanBottom } = spanNode.getBoundingClientRect();
          if (spanBottom - bottom > 2) {
            targetIndex = i;
            break;
          }
        }
        if (targetIndex !== undefined) {
          let ellipsisIndex = targetIndex - 1;
          const targetSpan = nodes[ellipsisIndex];
          if (targetSpan) {
            targetSpan.textContent = '...';
            const { width: targetNodeWidth, bottom: targetNodeBottom } =
              targetSpan.getBoundingClientRect();
            const { bottom: titleBottom, right: titleRight } = titleDom.getBoundingClientRect();
            // 如果替换为省略号后换到下一行
            if (targetNodeBottom - titleBottom > 2) {
              for (let i = ellipsisIndex - 1; i >= 0; i--) {
                const ellipsisNode = nodes[i];
                const { left } = ellipsisNode.getBoundingClientRect();
                // 找到距行尾宽度足够放下省略号的节点
                if (titleRight - left - targetNodeWidth > 2) {
                  ellipsisIndex = i;
                  ellipsisNode.textContent = '...';
                  break;
                }
              }
            }
            const ellipsisNode = nodes[ellipsisIndex];
            const { left } = ellipsisNode.getBoundingClientRect();
            // 宽度占满剩余空间，避免后面字符挤上来
            ellipsisNode.style.width = `${titleRight - left - 2}px`;
            ellipsisNode.style.textAlign = 'left';
            ellipsisNode.style.whiteSpace = 'nowrap';
          }
        }
      }
    }
  }, [text, posterId, containerRef.current, textsRef.current]);

  return {
    containerRef,
    textsRef,
    textDoms,
  };
}
